export default {
  title: "Tasks",
  routineTasks: "Routine Tasks",
  oneTimeTasks: "One Time Tasks",
  reportedTasks: "Reported Tasks",
  manageRoutineTask: "Manage Routine Task",
  createTask: "Create Task",
  editTask: "Edit Task",
  deleteTask: "Delete Task",
  taskDetails: "Task Details",
  taskName: "Task Name",
  taskDescription: "Task Description",
  taskStatus: "Task Status",
  taskPriority: "Task Priority",
  assignedTo: "Assigned To",
  dueDate: "Due Date",
  startDate: "Start Date",
  endDate: "End Date",
  createdAt: "Created At",
  updatedAt: "Updated At",
  status: {
    pending: "Pending",
    inProgress: "In Progress",
    completed: "Completed",
    cancelled: "Cancelled",
    onHold: "On Hold",
  },
  priority: {
    low: "Low",
    medium: "Medium",
    high: "High",
    urgent: "Urgent",
  },
  actions: {
    view: "View Task",
    edit: "Edit Task",
    delete: "Delete Task",
    complete: "Complete Task",
    assign: "Assign Task",
    comment: "Add Comment",
    attach: "Attach File",
  },
  comments: {
    title: "Comments",
    addComment: "Add Comment",
    noComments: "No comments yet",
    placeholder: "Write your comment here...",
  },
  attachments: {
    title: "Attachments",
    addAttachment: "Add Attachment",
    noAttachments: "No attachments",
    download: "Download",
    delete: "Delete",
  },
  evaluation: {
    title: "Evaluation",
    evaluate: "Evaluate Task",
    rating: "Rating",
    feedback: "Feedback",
  },
  // RoutineTask.vue translations
  addMember: "Add Member",
  email: "Email",
  emailExistsError:
    "This email is already registered. Please use another email.",
  generalError: "An error occurred while submitting. Please try again later.",
  invalidCompanyIdOrUserId: "Invalid Company ID or User ID.",
  routineTaskDeleted: "Routine Task deleted successfully.",
  routineTaskAdded: "Routine Task added successfully.",
  deleteConfirmationTitle: "Delete Routine Task",
  deleteConfirmationText: "Are you sure you want to delete this Routine Task?",
  delete: "Delete",
  addRoutineTask: "Add Routine Task",
  routineTaskName: "Routine Task Name",
  description: "Description",
  close: "Close",
  create: "Create",
  routineTasksTable: "Routine Tasks",
  routineTaskNameRequired: "Please enter the routine task name.",
  routineTaskAddedError:
    "An error occurred while adding the routine task. Please try again later.",
  from: "From",
  to: "To",
  routineTaskManager: "Routine Task Manager",
  assignManager: "Assign Manager",
  enterDescription: "Enter Description",
  enterRoutineTaskName: "Enter Routine Task Name",
  createRoutineTask: "Create Routine Task",
  saving: "Saving...",
  noRoutineTasks: "No routine tasks found.",
  createee: "Create your routine tasks",
  inactive: "Inactive",
  active: "Active",
  advancedSettings: "Advanced Settings",
  taskNumber: "Task Number",
  taskType: "Task Type",
  selectTaskType: "Select Task Type",
  recurrentDays: "Recurrent Days",
  enterRecurrentDays: "Enter number of recurrent days",
  dayOfMonth: "Day of Month",
  enterDayOfMonth: "Enter day of the month ex: 1, 2,....31",
  department: "Department",
  selectDepartment: "Select Department",
  sunday: "Sunday",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  enterStartDate: "Enter start date",
  allStatuses: "All Status",
  allDepartments: "All Departments",
  allProjects: "All Projects",
  projectsSelected: "Projects Selected",
  weekly: "Weekly",
  monthly: "Monthly",
  daily: "Daily",
  applyFilters: "Apply Filters",
  resetFilters: "Reset Filters",
  selectAll: "Select All",
  departmentsSelected: "Departments Selected",
  done: "Done",
  not_done: "Not Done",
  not_reported: "Not Reported",
  reported: "Reported",
  notPaid: "Not Paid",
  LatedTasks: "Lated Tasks",
  project: "Project",
  selectProject: "Select Project",
  searchPlaceholder: "Search tasks...",
  allTypes: "All Types",
  statusLabel: "Status",
  // RoutineTaskTable.vue translations
  tasksTable: "Tasks Table",
  edit: "Edit",
  deleteConfirmationSuccess: "Task deleted successfully.",
  update: "Update",
  taskUpdatedSuccessfully: "Task updated successfully",
  taskDeletedSuccessfully: "Task deleted successfully",
  taskReportedSuccessfully: "Task reported successfully",
  taskCreatedBy: "Created By",
  log: "Log",
  info: "Info",
  statusUpdatedSuccessfully: "Status updated successfully",
  errorUpdatingStatus: "Error updating status",
  errorUpdatingTask: "Error updating task",
  errorDeletingTask: "Error deleting task",
  noLogsAvailable: "No logs available",
  changedTheField: "changed the field",
  onDate: "On",
  noTasks: "No tasks found.",
  taskStartDate: "Task Start Date",
  taskDeadline: "Task Deadline",
  deadline: "Deadline",
  reportTaskType: "Report Task Type",
  dayOfWeek: "Day of Week",
  fromTime: "From Time",
  taskCreatedSuccessfully: "Task created successfully",
  taskCreatedSuccessfullyMessage: "Task created successfully",
  taskCreationError: "Error creating task",
  report: "Report",
  reportTask: "Report Task",
  selectReportTaskType: "Select Report Task Type",
  notes: "Notes",
  enterNotes: "Enter notes",
  employeeName: "Employee Name",
  taskFound: "There is task",
  selectTaskFound: "Select Task Found",
  criticalRoutineTasks: "Critical Routine Tasks",
};
